const BASE = import.meta.env["VITE_API_BASE_URL"] ?? "";
export async function apiFetch(path, init) {
    const url = `${BASE}${path}`;
    const res = await fetch(url, {
        headers: { "Content-Type": "application/json", ...init?.headers },
        ...init,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw Object.assign(new Error(`API error ${res.status}`), {
            status: res.status,
            data: err,
        });
    }
    if (res.status === 204)
        return undefined;
    return res.json();
}
//# sourceMappingURL=client.js.map